// Animate only server-masked text. Restored messages are never replayed.
export function createReplyAnimator(
  signal: AbortSignal,
  render: (text: string) => void,
) {
  let queue: string[] = [];
  let shown = "";
  let timer: ReturnType<typeof setTimeout> | undefined;
  let closed = false;
  let stopped = false;
  let resolve: () => void;
  const drained = new Promise<void>((done) => {
    resolve = done;
  });
  const cancel = () => {
    stopped = true;
    clearTimeout(timer);
    queue = [];
    signal.removeEventListener("abort", cancel);
    resolve();
  };
  const tick = () => {
    timer = undefined;
    if (stopped) return;
    // Catch up on long chunks without splitting Korean syllables/surrogate pairs.
    const count =
      document.hidden ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ? queue.length
        : Math.max(1, Math.ceil(queue.length / 90));
    shown += queue.splice(0, count).join("");
    render(shown);
    if (queue.length) timer = setTimeout(tick, 12);
    else if (closed) cancel();
  };
  signal.addEventListener("abort", cancel, { once: true });
  if (signal.aborted) cancel();
  return {
    append(text: string) {
      if (stopped || closed) return;
      queue.push(...Array.from(text));
      if (timer === undefined && queue.length) timer = setTimeout(tick, 12);
    },
    finish() {
      closed = true;
      if (!queue.length) cancel();
      return drained;
    },
    cancel,
  };
}
